import { useMutation, useQueryClient } from '@tanstack/react-query'
import { submitAddShareableListMembership } from './shareable-list.api'

export function useAddSpaceToShareableList() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['addSpaceToShareableList'],
    mutationFn: ({ listId, spaceId }: { listId: number; spaceId: number }) =>
      submitAddShareableListMembership({ listId, spaceId }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shareable-lists'] })
      queryClient.invalidateQueries({ queryKey: ['shareable-list'] })
    },
  })
}
